module.exports = __webpack_public_path__ + "static/media/bg1.ef96b0fd.jpg";